import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	margin: 1rem 0;
	border-radius: 0.5rem;
	border: 1px solid #d9d9d9;
`;
